import { WAITING_REASON_DETAIL_MARKER } from '@nightshift/ui-types';

export interface SplitWaitingReason {
  /** The breaker's (or the pipeline's) own sentence. Markdown, as it always was. */
  narrative: string;
  /** The last failed attempt's `failure_detail`, verbatim, or undefined when there was none. */
  detail?: string;
}

/**
 * Separate a waiting reason's sentence from the machine's own words.
 *
 * The reason is one string on the wire; only the drawer cares that the tail is a verbatim
 * failure detail, which must keep its line breaks and not be re-flowed as Markdown prose. A
 * reason with no marker -- every waiting reason that is not a tripped breaker -- comes back
 * unchanged.
 */
export function splitWaitingReason(reason: string): SplitWaitingReason {
  const at = reason.indexOf(WAITING_REASON_DETAIL_MARKER);
  if (at === -1) return { narrative: reason };
  const detail = reason.slice(at + WAITING_REASON_DETAIL_MARKER.length).trim();
  const narrative = reason.slice(0, at).trim();
  if (detail.length === 0) return { narrative };
  return { narrative, detail };
}
